import { connect } from 'react-redux';
import { EReadyStatus } from '../../../../types/filters';
import { changeReadyStatusFilter } from '../../../../store/filters/actions';
import { createExtraFilter, IExtraFilterProps } from '../helpers';
import { mapDispatchToPropsCreator, mapStateToPropsCreator } from '../creators';
import { READY_STATUSES } from '../../../../constants/filters';

export const ReadyStatusLongNames: { [key: string]: string } = {
  building: 'Готовность поселка: строится',
  built: 'Готовность поселка: построен',
  frozen: 'Готовность поселка: заморожен',
  planning: 'Готовность поселка: в проекте',
};

const ReadyStatusFilter = createExtraFilter<EReadyStatus>(READY_STATUSES);

type TReadyStatusFilterProps = IExtraFilterProps<EReadyStatus>;

export const ReadyStatusFilterContainer = connect<
  Pick<TReadyStatusFilterProps, 'selected'>,
  Pick<TReadyStatusFilterProps, 'toggle'>
>(
  mapStateToPropsCreator<EReadyStatus>('readyStatus'),
  mapDispatchToPropsCreator<EReadyStatus>(changeReadyStatusFilter),
)(ReadyStatusFilter);
